import { render } from "./menu-user.vue?vue&type=template&id=038c4146&ts=true"
import script from "./menu-user.vue?vue&type=script&lang=ts"
export * from "./menu-user.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__